import React from 'react';
import { View } from 'react-native';
import {
  addPathToList,
  file_size_success,
  getSubCategoryId,
  go_account_balance,
  More_details_per_transaction,
  Recent_account_transactions,
  Review_customer_sees,
  Show_link_transactions_list,
  success_image_str,
  Upload_assets,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import { arrangeScreenInJson } from '../screens/ScreensOrdering';
import SwitcherPanel from '../components/PanelsComponents/Buttons/SwitcherPanel';
import BreakLine from '../components/PanelsComponents/General/BreakLine';
import UploadMenu from '../components/PanelsComponents/Upload/UploadMenu';

//= ========================================================================
const Panel_C03_AccountInfoInOut = ({
  globJSON,
  selectedScreen,
  onStepPressed,
  onConfigChanged,
  language,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const service = globJSON.configurations.services[subCategoryId];
  const subCategoryIdDefault = getSubCategoryId({ sub_category: myScreen.sub_category, duplication_number: 0 });
  const { transactions } = service;
  const onValueChanged = (key, value) => {
    transactions[key] = value;
    arrangeScreenInJson(globJSON, onConfigChanged);
  };
  const editTextList = [
    'transaction_details',
    'confirm_action',
    'go_account_balance',
  ].filter((textElement) => {
    if (textElement === go_account_balance) {
      return transactions.show_link_transactions_list;
    }
    return true;
  });

  const listObject = [
    {
      subHeadline: success_image_str,
      fileId: 'configurations/general/success_image',
    },
  ];

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={Recent_account_transactions}
      tooltipsTitles={service.screens_ordering}
      paragraph={Review_customer_sees}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/transactions/`)}
      editTextListDefault={addPathToList(editTextList, `configurations/services/${subCategoryIdDefault}/transactions/`)}
      language={language}
      disableEditElements={!transactions.enable_more_details_per_transaction}
    >
      <SwitcherPanel
        text={More_details_per_transaction}
        value={transactions.enable_more_details_per_transaction}
        onValueChanged={(value) => {
          onValueChanged('enable_more_details_per_transaction', value);
        }}
      />
      {transactions.enable_more_details_per_transaction
            && (
            <View>
              <BreakLine marginTop={16} />
              <SwitcherPanel
                text={Show_link_transactions_list}
                value={transactions.show_link_transactions_list}
                onValueChanged={(value) => {
                  onValueChanged('show_link_transactions_list', value);
                }}
              />
              <UploadMenu
                globJSON={globJSON}
                onConfigChanged={onConfigChanged}
                headline={Upload_assets}
                details={file_size_success}
                listObject={listObject}
              />
            </View>
            )}
    </FullPagePanel>
  );
};

export default Panel_C03_AccountInfoInOut;
